import React from "react";
import StandardInstruction from "../StandardInstruction";
import ImageWithModal from "../ImageWithModal";

function PathBuilderInstructionsSatochip({ t, options }) {
  const show =
    options.storeKeyOnSatochip ||
    options.signTransactionWithSatochip ||
    options.importKeyFromSatochip ||
    options.backupSeedToSatochip;
  if (!show) return null;

  return (
    <div className="instruction-category-group">
      <h3 className="instruction-category-header">{t("pathBuilder.categories.seedsignerSatochip")}</h3>
      {options.storeKeyOnSatochip && (
        <StandardInstruction
          title={t("pathBuilder.instructionTitles.storeKeyOnSatochip")}
          icon="💾"
          intro={
            <div className="instruction-image-gallery">
              <h4 className="instruction-subsection-title">{t("pathBuilder.instructionContent.accessSmartcardFunctionsTitle")}</h4>
              <p>{t("pathBuilder.instructionContent.accessSmartcardFunctionsIntro")}</p>
              <div className="instruction-images-grid">
                <div className="instruction-image-item">
                  <ImageWithModal
                    src={`${process.env.PUBLIC_URL}/assets/images/seedsigner/image_video_06.png`}
                    alt={t("pathBuilder.instructionContent.accessSmartcardFunctionsImage1Alt")}
                  />
                  <p className="instruction-image-caption">{t("pathBuilder.instructionContent.accessSmartcardFunctionsImage1Caption")}</p>
                </div>
                <div className="instruction-image-item">
                  <ImageWithModal
                    src={`${process.env.PUBLIC_URL}/assets/images/seedsigner/image_video_07.png`}
                    alt={t("pathBuilder.instructionContent.accessSmartcardFunctionsImage2Alt")}
                  />
                  <p className="instruction-image-caption">{t("pathBuilder.instructionContent.accessSmartcardFunctionsImage2Caption")}</p>
                </div>
                <div className="instruction-image-item">
                  <ImageWithModal
                    src={`${process.env.PUBLIC_URL}/assets/images/seedsigner/image_video_08.png`}
                    alt={t("pathBuilder.instructionContent.accessSmartcardFunctionsImage3Alt")}
                  />
                  <p className="instruction-image-caption">{t("pathBuilder.instructionContent.accessSmartcardFunctionsImage3Caption")}</p>
                </div>
                <div className="instruction-image-item">
                  <ImageWithModal
                    src={`${process.env.PUBLIC_URL}/assets/images/seedsigner/image_video_09.png`}
                    alt={t("pathBuilder.instructionContent.accessSmartcardFunctionsImage4Alt")}
                  />
                  <p className="instruction-image-caption">{t("pathBuilder.instructionContent.accessSmartcardFunctionsImage4Caption")}</p>
                </div>
                <div className="instruction-image-item">
                  <ImageWithModal
                    src={`${process.env.PUBLIC_URL}/assets/images/seedsigner/image_video_10.png`}
                    alt={t("pathBuilder.instructionContent.accessSmartcardFunctionsImage5Alt")}
                  />
                  <p className="instruction-image-caption">{t("pathBuilder.instructionContent.accessSmartcardFunctionsImage5Caption")}</p>
                </div>
                <div className="instruction-image-item">
                  <ImageWithModal
                    src={`${process.env.PUBLIC_URL}/assets/images/seedsigner/image_video_11.png`}
                    alt={t("pathBuilder.instructionContent.accessSmartcardFunctionsImage6Alt")}
                  />
                  <p className="instruction-image-caption">{t("pathBuilder.instructionContent.accessSmartcardFunctionsImage6Caption")}</p>
                </div>
              </div>
            </div>
          }
          steps={{
            items: [
              t("pathBuilder.instructionContent.storeKeyOnSatochipStep1"),
              t("pathBuilder.instructionContent.storeKeyOnSatochipStep2"),
              {
                content: (
                  <>
                    {t("pathBuilder.instructionContent.storeKeyOnSatochipStep3")}
                    <div style={{ marginTop: "12px" }}>
                      <ImageWithModal
                        src={`${process.env.PUBLIC_URL}/assets/images/seedsigner/images_flash_02.jpg`}
                        alt="SeedSigner device showing Smartcard Tools menu with 'Satochip Functions' option highlighted"
                      />
                    </div>
                  </>
                ),
              },
              {
                content: (
                  <>
                    {t("pathBuilder.instructionContent.storeKeyOnSatochipStep4")}
                    <div style={{ marginTop: "12px" }}>
                      <ImageWithModal
                        src={`${process.env.PUBLIC_URL}/assets/images/seedsigner/images_flash_01.jpg`}
                        alt="SeedSigner device showing Satochip menu with 'Initialise with Seed' option highlighted"
                      />
                    </div>
                  </>
                ),
              },
              t("pathBuilder.instructionContent.storeKeyOnSatochipStep5"),
              t("pathBuilder.instructionContent.storeKeyOnSatochipStep6"),
              t("pathBuilder.instructionContent.storeKeyOnSatochipStep7"),
            ],
          }}
        />
      )}
      {options.signTransactionWithSatochip && (
        <StandardInstruction
          title={t("pathBuilder.instructionTitles.signTransactionWithSatochip")}
          icon="✍️"
          steps={{
            items: [
              t("pathBuilder.instructionContent.signTransactionWithSatochipStep1"),
              t("pathBuilder.instructionContent.signTransactionWithSatochipStep2"),
              t("pathBuilder.instructionContent.signTransactionWithSatochipStep3"),
              t("pathBuilder.instructionContent.signTransactionWithSatochipStep4"),
              t("pathBuilder.instructionContent.signTransactionWithSatochipStep5"),
              t("pathBuilder.instructionContent.signTransactionWithSatochipStep6"),
            ],
          }}
          note={{
            label: t("pathBuilder.instructionContent.importantNote"),
            text: t("pathBuilder.instructionContent.signTransactionWithSatochipNote"),
          }}
        />
      )}
      {options.importKeyFromSatochip && (
        <StandardInstruction
          title={t("pathBuilder.instructionTitles.importKeyFromSatochip")}
          icon="📥"
          steps={{
            items: [
              t("pathBuilder.instructionContent.importKeyFromSatochipStep1"),
              t("pathBuilder.instructionContent.importKeyFromSatochipStep2"),
              t("pathBuilder.instructionContent.importKeyFromSatochipStep3"),
              t("pathBuilder.instructionContent.importKeyFromSatochipStep4"),
              t("pathBuilder.instructionContent.importKeyFromSatochipStep5"),
              t("pathBuilder.instructionContent.importKeyFromSatochipStep6"),
              t("pathBuilder.instructionContent.importKeyFromSatochipStep7"),
            ],
          }}
        />
      )}
      {options.backupSeedToSatochip && (
        <StandardInstruction
          title={t("pathBuilder.instructionTitles.backupSeedToSatochip")}
          icon="💾"
          steps={{
            items: [
              t("pathBuilder.instructionContent.backupSeedToSatochipStep1"),
              t("pathBuilder.instructionContent.backupSeedToSatochipStep2"),
              t("pathBuilder.instructionContent.backupSeedToSatochipStep3"),
              t("pathBuilder.instructionContent.backupSeedToSatochipStep4"),
              t("pathBuilder.instructionContent.backupSeedToSatochipStep5"),
              t("pathBuilder.instructionContent.backupSeedToSatochipStep6"),
            ],
          }}
          note={{
            label: t("pathBuilder.instructionContent.importantNote"),
            text: t("pathBuilder.instructionContent.backupSeedToSatochipNote"),
          }}
        />
      )}
    </div>
  );
}

export default PathBuilderInstructionsSatochip;
